import { Component, Input, OnInit, EventEmitter, Output, Optional } from '@angular/core';
import { ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { SuffixInput, Warning } from '../../../../../utils/models/input.interface';
import { returnColorWarning, returnTextWarning, returnWarningIcon } from '../../../functions/utilities.service';

@Component({
  selector: 'suffix-input-induxtry',
  templateUrl: './suffix-input.component.html',
  styleUrls: ['./suffix-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SuffixInputComponent,
    },
  ],
})
export class SuffixInputComponent implements OnInit, ControlValueAccessor {
  warningIconSuffixInput = returnWarningIcon;
  colorWarningSuffixInput = returnColorWarning;
  textWarningSuffixInput = returnTextWarning;

  @Input() suffixInput: SuffixInput;

  @Input() warning: Warning;

  @Input() formControlName: string;

  @Output() valueEmitter: EventEmitter<string> = new EventEmitter<string>();

  constructor(@Optional() private controlContainer: ControlContainer) { }

  writeValue(value: string): void {
    this.suffixInput.value = value;
  }

  onChange = (value: any) => {
    this.suffixInput.value = value
    return value;
  };

  onTouched = (value: any) => {
    this.suffixInput.value = value
    return value;
  };

  registerOnChange(onChange: (value: any) => any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  ngOnInit(): void {
    if(this.controlContainer) {
      const control = this.controlContainer.control.get(this.formControlName);
      if (control && control.hasValidator(Validators.required)) {
        this.suffixInput.required.active = true;
      }
    }
  }

  setValue() {
    this.onChange(this.suffixInput.value);
    this.valueEmitter.emit(this.suffixInput.value);
  }
}
